import { FOOTER_TEXT } from '@mais-retorno-front/components/footer/constants';
import { CardHeader } from '@core/design-system/card';

export const AppFooterWithServiceTerms = () => (
  <CardHeader title="Aviso legal">
    <small
      dangerouslySetInnerHTML={{ __html: FOOTER_TEXT }}
      className="leading-2 block text-xs text-text-secondary font-light"
    />

    {/* <Typography
      component="small"
      variant="caption"
      sx={{ lineHeight: '14px', '& a': { lineHeight: '14px' } }} // add line height to the link
    /> */}
  </CardHeader>
);
